import { Step } from 'signup-constants/Step';
import { getFlowandNextSteps } from '../../flow-management/FlowStateManager';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { isExistingUserExistingAccount } from '../../app/verificationTypeSelectors';
import { setFlow } from '../../store/flow/action-creators';
import { getHttpResponse } from '../../store/http-responses/selectors';
import { EndpointKey } from '../../http/EndpointKey';
export const BranchAddHubletStandaloneCmsPartner = {
  name: 'BranchAddHubletStandaloneCmsPartner',
  stateCheck: state => {
    const httpResponse = getHttpResponse(state, EndpointKey.HubletChoiceExistingUser);
    return getIsAuthenticated(state) && isExistingUserExistingAccount(state) && Boolean(httpResponse) && httpResponse.availableHublets && httpResponse.availableHublets.length > 1;
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      flowSteps,
      oldNextSteps
    } = getFlowandNextSteps(state);
    dispatch(setFlow([...oldNextSteps, Step.HubletSelection], flowSteps.preVerification, flowSteps.postVerification, flowSteps.postAccountCreation, [...flowSteps.postExistingAccountSelection, Step.HubletSelection]));
    return [...oldNextSteps, Step.HubletSelection];
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};